import { render, staticRenderFns } from "./MapRestrictedArea.vue?vue&type=template&id=05770272&scoped=true&"
import script from "./MapRestrictedArea.vue?vue&type=script&lang=js&"
export * from "./MapRestrictedArea.vue?vue&type=script&lang=js&"
import style0 from "leaflet-draw/dist/leaflet.draw.css?vue&type=style&index=0&lang=css&"
import style1 from "./MapRestrictedArea.vue?vue&type=style&index=1&id=05770272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05770272",
  null
  
)

export default component.exports